export default function Label({ label }) {
  return (
    <label class="label">
      <span class="label-text after:content-['*'] after:ml-0.5 after:text-red-500">
        {label}
      </span>
    </label>
  );
}
